import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { boxSummaryVisibilityChange } from 'actions/boxSummary'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketRecipesCount } from 'selectors/basket'

import { setCuratedBox } from '../../actions/menuRecipeDetails'
import { trackCuratedBox } from '../trackCuratedBox'

export const useAddCuratedBoxRecipes = (hasSeenWarningModal: boolean) => {
  const { addRecipe, numPortions, menuId } = useBasket()
  const basketRecipesCount = useSelector(getBasketRecipesCount)
  const dispatch = useDispatch()

  const addCuratedBoxRecipes = useCallback(
    (selectedCuratedBox) => {
      const { curatedBoxRecipes, curatedBoxCollectionId, curatedBoxName } = selectedCuratedBox
      dispatch(setCuratedBox(curatedBoxCollectionId, curatedBoxName))
      curatedBoxRecipes.forEach((recipe: string) => {
        addRecipe(recipe, undefined, undefined, undefined, undefined, true)
      })
      dispatch(boxSummaryVisibilityChange(true, () => {}))

      const isAddCuratedBox = true
      dispatch(
        trackCuratedBox(
          numPortions,
          curatedBoxName,
          curatedBoxRecipes,
          curatedBoxCollectionId,
          menuId,
          hasSeenWarningModal,
          basketRecipesCount,
          isAddCuratedBox,
        ),
      )
    },
    [addRecipe, basketRecipesCount, dispatch, hasSeenWarningModal, menuId, numPortions],
  )

  return { addCuratedBoxRecipes }
}
